import React from 'react';
import Header from './shared/Header';
import { useRandomLinkColors } from '../utils/useRandomLinkColors';
import { getRandomColor } from '../utils/colors';
const SaturdayCritiqueGroupPage = () => {
  useRandomLinkColors();
  return <div className="min-h-screen bg-[#faf9f7] text-[#333333] font-serif" data-id="element-571" data-mp="1uyntvhtokbp0">
      <Header data-id="element-572" data-mp="1zxgx8hf96mbg" />
      <main className="flex min-h-screen pt-24 px-6 pb-16" data-id="element-573" data-mp="1zvw2orsxv3dl">
        {/* Mobile Layout */}
        <div className="md:hidden w-full max-w-2xl mx-auto" data-id="element-574" data-mp="137zt46vx58bv">
          <h1 className="text-4xl font-bold mb-8 leading-tight" data-id="element-575" data-mp="178jnj2p3xxub">
            Saturday Critique Group 2
          </h1>

          <div className="text-base mb-8" data-id="element-576" data-mp="1c73b17jcnhos">
            <div className="font-bold mb-2" data-id="element-577" data-mp="1c6bg7yxktnzk">Dates:</div>
            <div data-id="element-578" data-mp="1h6zixhv63t9m">Starts 12th December, 2026.</div>
            <div data-id="element-579" data-mp="1h4mqubvp42iu">Saturday from 9am - 11:30am ET.</div>
            <div className="mb-4" data-id="element-580" data-mp="2nnkywj8vsbzt">
              Six Months: Meets on the Second Saturday of Each Month.
            </div>

            <div data-id="element-581" data-mp="2skbe74cv33k6">Six Group Sessions & One 30-minute One-on-One Session</div>
            <div className="mb-4" data-id="element-582" data-mp="3oae2uut152ra">
              (12th December, January 9th, February 13th, March 13th, April
              10th, and May 8th.)
            </div>

            <div className="mb-1" data-id="element-583" data-mp="3f9g00fubv1aa">
              <a href="https://www.paypal.com/ncp/payment/ZPY6PXTX3QVBY" target="_blank" rel="noopener noreferrer" className="font-bold text-blue-600 transition-colors duration-200" onMouseEnter={e => {
              e.currentTarget.style.color = getRandomColor();
            }} onMouseLeave={e => {
              e.currentTarget.style.color = '#2563eb';
            }} data-id="element-584" data-mp="3f8d9wa4tx2vf">
                REGISTER HERE
              </a>
            </div>
            <div className="italic mb-4" data-id="element-585" data-mp="2mkr4qxfydq6g">
              Questions? Email{' '}
              <a href="mailto:mm@madeleinemorlet.com" className="transition-colors duration-200" onMouseEnter={e => {
              e.currentTarget.style.color = getRandomColor();
            }} onMouseLeave={e => {
              e.currentTarget.style.color = '#333333';
            }} data-id="element-586" data-mp="2mmv6b8qdqd3k">
                mm@madeleinemorlet.com
              </a>
            </div>

            <div className="font-bold mb-2" data-id="element-587" data-mp="2300dzne4g7di">Location:</div>
            <div data-id="element-588" data-mp="2qojli0pckg4j">All sessions will take place over Zoom.</div>
            <div className="mb-4" data-id="element-589" data-mp="2qpbk7ke8qtz1">
              Class recordings and any assignments will be shared via email.
            </div>

            <div data-id="element-590" data-mp="2hw7yypxctctu">Fee: $600 USD</div>
            <div className="mb-4" data-id="element-591" data-mp="2hx15bpsei0bg">
              Refunds available up to 30 days before the first session (12th
              November).
            </div>

            <div data-id="element-592" data-mp="2lvgrxskkl6oc">Critique group limited to six attendees.</div>
          </div>

          <img src="https://cdn.magicpatterns.com/uploads/xzsWcMf8V6HwxKoQAg37D5/Lidl_Peonies_2026.jpg" alt="Pink and white peonies" className="w-full h-auto mb-8" data-id="element-593" data-mp="39m4e9iv8fyuf" />

          <div className="text-base leading-relaxed space-y-4 mb-8" data-id="element-594" data-mp="12wslkvjuug46">
            <div className="font-bold mb-2" data-id="element-595" data-mp="xzj0fs3i0qm5">Critique Group 2:</div>
            <p data-id="element-596" data-mp="1cphxtsn8by0k">
              This ongoing critique group offers a sustained and intimate
              structure for photographers who have an established practice and
              are looking for support as they continue developing ongoing
              projects or plan to begin new ones. The aim is to make meaningful
              work and build momentum alongside a thoughtful cohort of fellow
              artists. Participants can expect to present work monthly, and to
              be provided with (optional) writing exercises and inspiring
              photography prompts for between sessions.
            </p>
            <p data-id="element-597" data-mp="25cax06kz0p8g">
              Taking cues from the Iowa Writers' Workshop, participants will
              present their work for discussion without explanation, allowing
              them to 'see' it as others do. All group members will submit their
              images by the Wednesday prior to our sessions, giving them the
              opportunity to review one another's work in advance – and to
              arrive ready to offer generous and constructive feedback.
            </p>
            <p data-id="element-598" data-mp="ny9p1o7rb5i2">
              Within the six-month period, each participant will have a
              dedicated thirty-minute one-on-one with the instructor to reflect
              on their project's development and discuss its next steps.
            </p>
          </div>

          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/dcDGGrrwFtUCkeLK9Mn7qj/Madeleine-Morlet_Headshot.jpg" alt="Madeleine Morlet" className="w-32 h-auto mb-4" data-id="element-599" data-mp="12lkxvick0beh" />

          <div className="text-base leading-relaxed" data-id="element-600" data-mp="1bnu621kcnsop">
            <div className="font-bold mb-2" data-id="element-601" data-mp="1glvp4mhrzs06">Instructor:</div>
            <p data-id="element-602" data-mp="1gmds01yy14h2">
              Madeleine Morlet is a British-American photographer based in
              London. Her teaching centers on the narrative potential of
              photography and the photobook form, informed by her background in
              filmmaking and creative writing. She combines editorial feedback
              with practical strategy to help students both refine their vision
              and sustain creative practices, guiding them toward publication.
              An award-winning photographer recognised by institutions including
              PhotoVogue and the Lucie Foundation, she brings both professional
              experience and artistic insight into the classroom.
            </p>
          </div>
        </div>

        {/* Desktop Layout */}
        <div className="hidden md:flex flex-row w-full max-w-6xl mx-auto gap-12" data-id="element-603" data-mp="1vo4690hsi7ku">
          <div className="w-full md:w-1/2 flex flex-col gap-8" data-id="element-604" data-mp="2s71qp9q2pert">
            <img src="https://cdn.magicpatterns.com/uploads/xzsWcMf8V6HwxKoQAg37D5/Lidl_Peonies_2026.jpg" alt="Pink and white peonies" className="w-full h-auto" data-id="element-605" data-mp="2ng3a0916aeo1" />

            <div className="flex-1 flex flex-col justify-end" data-id="element-606" data-mp="qi5nudg5yw0f">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/dcDGGrrwFtUCkeLK9Mn7qj/Madeleine-Morlet_Headshot.jpg" alt="Madeleine Morlet" className="w-32 h-auto mb-4" data-id="element-607" data-mp="qjp2y0q3310m" />

              <div className="text-base leading-relaxed" data-id="element-608" data-mp="2rib9evazi7j">
                <div className="font-bold mb-2" data-id="element-609" data-mp="2u4i1caddtop">Instructor:</div>
                <p data-id="element-610" data-mp="7rwac7exfhtf">
                  Madeleine Morlet is a British-American photographer based in
                  London. Her teaching centers on the narrative potential of
                  photography and the photobook form, informed by her background
                  in filmmaking and creative writing. She combines editorial
                  feedback with practical strategy to help students both refine
                  their vision and sustain creative practices, guiding them
                  toward publication. An award-winning photographer recognised
                  by institutions including PhotoVogue and the Lucie Foundation,
                  she brings both professional experience and artistic insight
                  into the classroom.
                </p>
              </div>
            </div>
          </div>

          <div className="w-full md:w-1/2" data-id="element-611" data-mp="3hmab1w74ta4w">
            <div className="max-w-2xl" data-id="element-612" data-mp="3vegsrmpxnp6g">
              <h1 className="text-4xl md:text-5xl font-bold mb-8 leading-tight" data-id="element-613" data-mp="3vhl5j8hgrt8q">
                Saturday Critique Group 2
              </h1>

              <div className="text-base mb-8" data-id="element-614" data-mp="98tmmnc9vpem">
                <div className="font-bold mb-2" data-id="element-615" data-mp="97ii2lb06dmg">Dates:</div>
                <div data-id="element-616" data-mp="48xjeqbeg204">Starts 12th December, 2026.</div>
                <div data-id="element-617" data-mp="47e2qyltzoxt">Saturday from 9am - 11:30am ET.</div>
                <div className="mb-4" data-id="element-618" data-mp="2b0g6m4xqyk1l">
                  Six Months: Meets on the Second Saturday of Each Month.
                </div>

                <div data-id="element-619" data-mp="262ocd49mqlu8">Six Group Sessions & One 30-minute One-on-One Session</div>
                <div className="mb-4" data-id="element-620" data-mp="1k6v4kqnvuyed">
                  (12th December, January 9th, February 13th, March 13th,
                  April 10th, and May 8th.)
                </div>

                <div className="mb-1" data-id="element-621" data-mp="1tyisihl8dxb3">
                  <a href="https://www.paypal.com/ncp/payment/ZPY6PXTX3QVBY" target="_blank" rel="noopener noreferrer" className="font-bold text-blue-600 transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#2563eb';
                }} data-id="element-622" data-mp="1tzk3yn65sltc">
                    REGISTER HERE
                  </a>
                </div>
                <div className="italic mb-4" data-id="element-623" data-mp="2rkpzfy50c1qm">
                  Questions? Email{' '}
                  <a href="mailto:mm@madeleinemorlet.com" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-624" data-mp="fxmnt6ayq78b">
                    mm@madeleinemorlet.com
                  </a>
                </div>

                <div className="font-bold mb-2" data-id="element-625" data-mp="3odobcweqjtsn">Location:</div>
                <div data-id="element-626" data-mp="3ofity42jb9tk">All sessions will take place over Zoom.</div>
                <div className="mb-4" data-id="element-627" data-mp="3jfef0ih9yn5g">
                  Class recordings and any assignments will be shared via email.
                </div>

                <div data-id="element-628" data-mp="3ehl6hisi1h20">Fee: $600 USD</div>
                <div className="mb-4" data-id="element-629" data-mp="1hn8cbhybt03e">
                  Refunds available up to 30 days before the first session
                  (12th November).
                </div>

                <div data-id="element-630" data-mp="2uwpgd0q1jdfa">Critique group limited to six attendees.</div>
              </div>

              <div className="text-base leading-relaxed space-y-4" data-id="element-631" data-mp="2uyis2ufignu5">
                <div className="font-bold mb-2" data-id="element-632" data-mp="2px334ra7px6h">Critique Group 2:</div>
                <p data-id="element-633" data-mp="33xnp1wbfc947">
                  This ongoing critique group offers a sustained and intimate
                  structure for photographers who have an established practice
                  and are looking for support as they continue developing
                  ongoing projects or plan to begin new ones. The aim is to make
                  meaningful work and build momentum alongside a thoughtful
                  cohort of fellow artists. Participants can expect to present
                  work monthly, and to be provided with (optional) writing
                  exercises and inspiring photography prompts for between
                  sessions.
                </p>
                <p data-id="element-634" data-mp="1oh5bu4x99j7c">
                  Taking cues from the Iowa Writers' Workshop, participants will
                  present their work for discussion without explanation,
                  allowing them to 'see' it as others do. All group members will
                  submit their images by the Wednesday prior to our sessions,
                  giving them the opportunity to review one another's work in
                  advance – and to arrive ready to offer generous and
                  constructive feedback.
                </p>
                <p data-id="element-635" data-mp="1x3ptdv58zpkz">
                  Within the six-month period, each participant will have a
                  dedicated thirty-minute one-on-one with the instructor to
                  reflect on their project's development and discuss its next
                  steps.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>;
};
export default SaturdayCritiqueGroupPage;